import React, { Component } from "react";
import { Typography, Link } from '@material-ui/core';

class Footer extends Component {

    render() {
        return  <Typography component={'span'} variant="body2" align="center" className="login-footer">
                    {'DESENVOLVIDO POR '}
                    <div className='footer-login'>
                        <Link color="inherit" href="https://www.dataa.com.br">
                            <img src='https://www.dataa.com.br/wp-content/uploads/2021/03/Data-A-Soluc%CC%A7o%CC%83es-150x62.png'  alt="Logo Data A"/>
                        </Link>
                    </div>
                </Typography>
        
    }
}


export default Footer;